export default {
  'common.more': 'المزيد',
  'common.fold': 'قابلة للطي',
  'common.noData': 'عدد لا يحصى من الوثائق',
  'common.success': 'نجحت العملية',
  'common.docTitle': 'BREAKER PART (HEBEI) MACHINERY TECHNOLOGY CO., LTD.'
}
